import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import useAuth from './hooks/useAuth';
import MentorLayout from './components/layout/MentorLayout';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import ReviewQueuePage from './pages/ReviewQueuePage';
import ReviewDetailPage from './pages/ReviewDetailPage';
import ProfilePage from './pages/ProfilePage';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

function ProtectedRoute({ children }) {
  const { isAuthenticated, isMentor, loading } = useAuth();

  if (loading) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!isAuthenticated || !isMentor) {
    return <Navigate to="/login" replace />;
  }

  return children;
}

function PublicRoute({ children }) {
  const { isAuthenticated, isMentor, loading } = useAuth();

  if (loading) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (isAuthenticated && isMentor) {
    return <Navigate to="/" replace />;
  }

  return children;
}

const routes = [
  { path: '/', element: <DashboardPage /> },
  { path: '/queue', element: <ReviewQueuePage /> },
  { path: '/queue/:assessmentId', element: <ReviewDetailPage /> },
  { path: '/profile', element: <ProfilePage /> },
];

function AppRoutes() {
  return (
    <Routes>
      <Route
        path="/login"
        element={
          <PublicRoute>
            <LoginPage />
          </PublicRoute>
        }
      />
      {routes.map((r) => (
        <Route
          key={r.path}
          path={r.path}
          element={
            <ProtectedRoute>
              <MentorLayout>{r.element}</MentorLayout>
            </ProtectedRoute>
          }
        />
      ))}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}
